document.addEventListener('DOMContentLoaded', function () {
  const copyButton = document.querySelector('[data-copy-hashtags]');
  const toast = document.getElementById('copy-toast');
  const hashtags = '#ハグユーキャンペーン #新感覚デニム #jp144';

  if (copyButton) {
    copyButton.addEventListener('click', async function () {
      const originalText = copyButton.innerText;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(hashtags);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = hashtags;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          textarea.style.left = '-9999px';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }

        if (toast) {
          toast.classList.add('show');
          setTimeout(function () {
            toast.classList.remove('show');
          }, 2500);
        }

        copyButton.classList.add('is-copied');
        copyButton.innerText = 'COPIED!';

        setTimeout(function () {
          copyButton.classList.remove('is-copied');
          copyButton.innerText = originalText;
        }, 2500);
      } catch (error) {
        console.error('Copy failed:', error);
        alert('コピーに失敗しました。手動でコピーしてください。');
      }
    });
  }

  const targets = document.querySelectorAll(
    '.outline-prize-list li, .step-desc-notice-text, .outline-footer-text'
  );

  targets.forEach(function (el) {
    const text = (el.textContent || '').trim();
    if (text.startsWith('・') || text.startsWith('※')) {
      el.classList.add('hanging-indent');
    }
  });

  initGalleryLoop();
});

window.addEventListener('scroll', function () {
  const bar = document.getElementById('FBar');
  const triggerBtn = document.getElementById('HeroBtn');

  if (!bar || !triggerBtn) return;

  const rect = triggerBtn.getBoundingClientRect();

  if (rect.bottom < 0) {
    bar.classList.add('is-visible');
  } else {
    bar.classList.remove('is-visible');
  }
});

function initGalleryLoop() {
  const track = document.getElementById('galleryTrack');
  const viewport = document.querySelector('.gallery-viewport');
  if (!track || !viewport) return;

  if (track.dataset.loopInitialized === 'true') return;
  track.dataset.loopInitialized = 'true';

  const originalItems = Array.from(track.children);
  if (originalItems.length === 0) return;

  let animationId = null;
  let currentX = 0;
  let originalWidth = 0;
  const speed = 0.5;
  let isBuilt = false;

  function getGap() {
    const style = window.getComputedStyle(track);
    return parseFloat(style.gap || 0);
  }

  function calcOriginalWidth() {
    const gap = getGap();
    originalWidth = 0;

    originalItems.forEach(function (item, index) {
      originalWidth += item.offsetWidth;
      if (index < originalItems.length - 1) {
        originalWidth += gap;
      }
    });
  }

  function removeClones() {
    track.querySelectorAll('[data-gallery-clone="true"]').forEach(function (el) {
      el.remove();
    });
  }

  function fillTrack() {
    removeClones();
    calcOriginalWidth();

    const viewportWidth = viewport.offsetWidth;
    const minNeededWidth = viewportWidth + originalWidth * 2;

    let currentTrackWidth = originalWidth;
    let cloneRound = 0;

    while (currentTrackWidth < minNeededWidth) {
      originalItems.forEach(function (item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-gallery-clone', 'true');
        track.appendChild(clone);
      });

      cloneRound++;
      currentTrackWidth = originalWidth * (cloneRound + 1);
    }
  }

  function tick() {
    currentX -= speed;

    if (Math.abs(currentX) >= originalWidth) {
      currentX += originalWidth;
    }

    track.style.transform = `translate3d(${currentX}px, 0, 0)`;
    animationId = requestAnimationFrame(tick);
  }

  function start(resetPosition = false) {
    if (animationId) cancelAnimationFrame(animationId);

    if (!isBuilt) {
      fillTrack();
      isBuilt = true;
    }

    if (resetPosition) {
      currentX = 0;
      track.style.transform = 'translate3d(0, 0, 0)';
    }

    animationId = requestAnimationFrame(tick);
  }

  function stop() {
    if (animationId) {
      cancelAnimationFrame(animationId);
      animationId = null;
    }
  }

  const images = track.querySelectorAll('img');
  if (images.length === 0) {
    start(true);
    return;
  }

  let loadedCount = 0;
  function handleLoaded() {
    loadedCount += 1;
    if (loadedCount === images.length) {
      start(true); // 初回だけ先頭から
    }
  }

  images.forEach(function (img) {
    if (img.complete) {
      handleLoaded();
    } else {
      img.addEventListener('load', handleLoaded, { once: true });
      img.addEventListener('error', handleLoaded, { once: true });
    }
  });

  window.addEventListener('resize', function () {
    stop();
    isBuilt = false;
    start(true); // リサイズ時は再計算のため先頭から組み直し
  });

  track.addEventListener('mouseenter', stop);
  track.addEventListener('mouseleave', function () {
    start(false); // 停止位置から再開
  });
}